module.exports = __webpack_public_path__ + "media/images/admin/node_builder_img/icons/data_annotation-474a5316a81b9e63861e5f9bda04e005.svg";